module.exports = __webpack_public_path__ + "img/pilotos.d8bd8431.png";